'use strict';

var classes = {"bf-privacy-badge":"bf-privacy-badge__8UA1d","bf-privacy-badge__icon":"bf-privacy-badge__icon__RrP23","bf-privacy-badge__label":"bf-privacy-badge__label__cwj1G","bf-status__circle--private":"bf-status__circle--private__0OY-I","bf-status__circle--public":"bf-status__circle--public__VxlED","bf-status__circle--stealth":"bf-status__circle--stealth__646O4"};

module.exports = classes;
//# sourceMappingURL=privacy-badge.module.scss.js.map
